const ExhibitorCategories = `
  fragment ExhibitorCategories on ExhibitorCategoryDetail {
    title
  }
`
export default ExhibitorCategories
